<template>
  <div>
    <Teleport
      to="#form-app"
      :disabled="!ussIsStartScreen"
    >
      <Form
        v-if="ussProps"
        v-bind="ussProps"
        :show-original-component="true"
      />
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import Form from './Form.vue';
import { useFormState } from '~/composables/useFormState.js';

const { ussProps, ussIsStartScreen } = useFormState();
</script>
